import React from 'react';
import PropTypes from 'prop-types';

import { supportedLocales } from '../../../../data/locale';
import { flag } from './styles.module.css';

/**
 * A flag in the user menu so people know what locale the site is in
 */
const UserMenuLocaleFlag = (props) => {
  const { userSelectedLocale } = props;

  if (!userSelectedLocale) {
    return null;
  }

  const locale = supportedLocales.find((l) => l.iso2 === userSelectedLocale);
  if (!locale) return null;

  const { emoji, labelLong } = locale;

  if (!emoji || !labelLong) return null;

  return (
    <div className={flag} alt={`Locale set to ${labelLong}`}>
      {emoji}
    </div>
  );
};

UserMenuLocaleFlag.propTypes = {
  /**
   * String class names to append to component styles.
   */
  userSelectedLocale: PropTypes.string,
};

UserMenuLocaleFlag.defaultProps = {
  userSelectedLocale: undefined,
};

export default UserMenuLocaleFlag;
